
import { defineComponent, reactive, toRefs, computed } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import { RepairItemTreeService } from './repair-item-tree.service'
import { SystemWrapperService } from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/system-wrapper.service'
import { BaseLineRepairDrawerService } from '@/views/dashboard/safe-status/base-line/_components/baseLine-repair-drawer/baseLine-repair-drawer.service'
import { HandleType, RepairTreeItem } from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'

const HandleTypeMap = {
  1: 'autoIDs',
  2: 'notifyIDs',
  3: 'ignoreIDs'
}
export default defineComponent({
  props: {
    repairType: {
      type: Number,
      default: 1
    },
    updateChange: {
      type: Function,
      default: () => ({})
    }
  },
  setup (props) {
    const injector = useReflectiveInjector([])
    const service = injector.get(RepairItemTreeService)
    const parentService = injector.get(SystemWrapperService)
    const rootService = injector.get(BaseLineRepairDrawerService)
    const { t } = useI18n()

    const options = computed(() => [
      { key: 1, label: t('safeProtectionModule.baselineItemAutoFix'), value: 1 },
      { key: 2, label: t('safeProtectionModule.baselineItemNotifyOnly'), value: 2 },
      { key: 3, label: t('safeProtectionModule.baselineItemIgnore'), value: 3 }
    ])

    const HandleTypeTxtMap = computed(() => ({
      1: t('safeProtectionModule.baselineAutoFixItems'),
      2: t('safeProtectionModule.baselineNotifyItems'),
      3: t('safeProtectionModule.baselineIgnoreItems')
    }))

    const data = reactive({
      SUB_IDS: [],
      TREE_ITEM: [],
      TREE_EXPAND_KEYS: [],
    })
    parentService[HandleTypeMap[props.repairType]].subscribe((ids: string[]) => {
      data.SUB_IDS = ids
      data.TREE_ITEM = service.generateRenderTree(ids)
      data.TREE_EXPAND_KEYS = data.TREE_ITEM.length ? [data.TREE_ITEM[0]?.id] : []
    })
    return {
      ...toRefs(data),
      HandleType,
      HandleTypeTxtMap,
      options,
      defaultProps: {
        children: 'items',
        label: 'name',
      },
      changeHandleType (type:HandleType, originalType:HandleType, nData: RepairTreeItem) {
        props.updateChange(originalType, type, nData.id)
      },
      isSelfItem (id: string) {
        return rootService.isInCollection(HandleType.NOTIFY, id)
      }
    }
  }
})
